import React from 'react'
import { Button, CircularProgress, Stack } from '@mui/material'
import { PhotoCameraFrontOutlined as PhotoCameraFrontOutlinedIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

function IdentificationPhotoButton({
  onClick,
  identificationPhoto = '',
  saveIdentificationPhoto = false,
  loading = false,
}) {
  const { t } = useTranslation()
  const showIdentificationPreview = Boolean(identificationPhoto && saveIdentificationPhoto)

  return (
    <Button
      variant="outlined"
      size='large'
      onClick={onClick}
      disabled={loading}
      sx={{ borderRadius: '8px', border: '1px solid' }}
    >
      {loading ?
        <Stack direction="row" gap={1} alignItems="center">
          <CircularProgress size={18} />
          <span className='take-credential-text open'>{t('See ID')}</span>
        </Stack> :
        showIdentificationPreview ?
        <Stack direction="row" gap={1}>
          <img src={identificationPhoto} alt={t('identification')} className='identification-photo' />
          <span className='take-credential-text open'>{t('See ID')}</span>
        </Stack> :
        <Stack direction="row" gap={1}>
          <PhotoCameraFrontOutlinedIcon />
          <span className='take-credential-text open'>{t('Capture ID')}</span>
        </Stack>
      }
    </Button>
  )
}

export default IdentificationPhotoButton
